import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-itk',
  templateUrl: './itk.component.html',
  standalone: false
})
export class ItkComponent {
  @Input() content = '';
  @Input() items: string[] = [];
  @Input() classes = '';
  @Input() id = '';
  @Input() linked = false;
  @Input() active = false;
  currentSlide = 0;

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 300,
    dots: false,
    arrows: true,
    fade: true,
    infinite: false,
    adaptiveHeight: true,
    variableWidth: false,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="#right-small"></use></svg></button>',
    rows: 0,
  };

  get displayItems(): string[] {
    return this.items?.length ? this.items : [this.content || ''];
  }

  beforeChange(event: {nextSlide?: number}): void {
    this.currentSlide = event?.nextSlide ?? 0;
  }
}